// frontend/src/pages/PostLoginPage.js
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { useBlog } from '../context/BlogContext';
import { useBlogModal } from '../context/BlogModalContext';
import { useAuth } from '../context/AuthContext';
import axios from '../services/axios';

function PostLoginPage() {
  const navigate = useNavigate();
  const { blogs, loading } = useUser();
  const { selectBlog } = useBlog();
  const { openBlogSelectModal } = useBlogModal();
  const { refreshBlogAuthz, isPlatformAdmin } = useAuth();

  const didActRef = useRef(false);

  useEffect(() => {
    if (didActRef.current) return;
    if (loading) return;

    if (!Array.isArray(blogs)) return;

    // ✅ NEW: zero blogs case
    if (blogs.length === 0) {
      didActRef.current = true;

      // platform admin goes to platform admin page (to create first blog)
      if (isPlatformAdmin) {
        navigate('/platform-admin', { replace: true }); // or '/platform-admin/create-blog'
      } else {
        navigate('/no-blogs', { replace: true }); // optional page, or just '/dashboard' with message
      }
      return;
    }

    const goDashboard = () => {
      didActRef.current = true;
      navigate('/dashboard');
    };

    // 1 blog => auto select
    if (blogs.length === 1) {
      (async () => {
        try {
          const b = blogs[0];
          const res = await axios.get(`/api/blogs/${b.slug}/metadata/`);
          const fullBlog = { ...res.data };

          selectBlog(fullBlog);
          await refreshBlogAuthz();
          goDashboard();
        } catch (err) {
          console.error('Failed to load blog metadata:', err);
          didActRef.current = false;
        }
      })();
      return;
    }

    // multiple blogs => open selector ONCE
    didActRef.current = true;
    openBlogSelectModal(async (selectedBlog) => {
      try {
        selectBlog(selectedBlog);
        await refreshBlogAuthz();
        navigate('/dashboard');
      } catch (err) {
        console.error('Blog select flow failed:', err);
        didActRef.current = false;
      }
    });
  }, [loading, blogs, selectBlog, openBlogSelectModal, refreshBlogAuthz, navigate, isPlatformAdmin]);

  // ✅ Replace debug JSON with a simple “loading” view
  return (
    <div style={{ padding: 16 }}>
      Loading…
    </div>
  );
}

export default PostLoginPage;
